export const enums = {
	TYPE: ['Nutrient', 'Energy']
};
